import VisualRest from './VisualRest';

export default VisualRest;
